import { motion } from "framer-motion";
import React from "react";

type DotProps = {
  className?: string;
} & React.ComponentProps<typeof motion.div>;

export function Dot({ className, ...props }: DotProps) {
  return (
    <motion.div className={`rounded-full shadow-lg ${className}`} {...props} />
  );
}
